import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ColorBox from './components/ColorBox';
import ChartBox from './components/ChartBox';
import PieChartBox from './components/PieChartBox';
import ColorFilter from './components/ColorFilter';
import ChartFilter from './components/ChartFilter';
import { colorBox, chartBox, ColorParams, ChartParams, PieChartParams } from '../constants/project';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import { message  } from 'antd';
import ExportModal from './components/ExportModal'

class Dashboard extends Component {
    static contextTypes = {
        systemDate: PropTypes.object,
        activeKey: PropTypes.string,
    }

    constructor(props, context) {
        super(props);
        const { systemDate } = context;
        const colorParams = {...ColorParams};
        colorParams.statisticDate = systemDate.monthDate;
        const chartParams = {...ChartParams};
        chartParams.statisticDate = systemDate.trueYear;
        const pieChartParams = {...PieChartParams};
        pieChartParams.statisticDate = systemDate.monthDate;
        this.state = {
            refreshColor: null,
            refreshChart: null,
            refreshPieChart: null,
            colorParams,
            chartParams,
            pieChartParams
        };
    }

    handleExport = (type,value = []) => {
        const { activeKey } = this.context;
        const params = this.state[`${type}Params`];
        const detailType = value.join(',')
        const Url = {
            color: API_URL.dashboard.exportInvSiteIndexAnalysisByMonth,
            chart: API_URL.dashboard.exportInvSiteIndexAnalysisByYear,
        };
        const { areaParams, investigationMedicineType = [] } = params;
        const setParams = type=="color"?ColorParams:ChartParams;
        Fetch.post(Url[type], {
            ...params,
            ...setParams[activeKey],
            ...areaParams,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
            detailType
        }).then(res => {
            message.success(res.success);
        });
    }

    exportModalShow = (type,params) => {
        this.exportModalRef.show(type, params)
    }

    handleSearch = (type) => {
        this.setState({ [`refresh${type.replace(/^\w/, m => m.toUpperCase())}`]: {} });
    }

    handleChange = (value, type) => {
        this.setState({ [`${type}Params`]: value });
    }

    render() {
        const { activeKey } = this.context;
        const { colorParams, refreshColor, chartParams, refreshChart, pieChartParams, refreshPieChart } = this.state;
        const charts = chartBox[activeKey];
        const pieCharts = charts.filter(chart => chart.chartTypes.includes('pie'))||[];
        const hasPieCharts = pieCharts&&pieCharts.length > 0;
        const colorNotShow = colorParams.lineOfBusiness != '-1' || colorParams.investigationMedicineType || colorParams.leaderUserName;
        const chartNotShow = chartParams.lineOfBusiness != '-1' || chartParams.investigationMedicineType || chartParams.leaderUserName;
        return (
            <div>
                <ColorFilter
                    params={colorParams}
                    activeKey={activeKey}
                    onExport={() => this.exportModalShow('color',colorParams)}
                    onSearch={() => this.handleSearch('color')}
                    onChange={value => this.handleChange(value, 'color')}
                />
                <div className={activeKey == 'scale' ? "specialColorWrap" : "colorWrap"}>
                    {
                        colorBox[activeKey].map(item => {
                            // "当月项目计划FTE/当月项目确认FTE"色块显示判断
                            const planFteColorNotShow = colorParams.statisticalRange !== "PROJECT" && item.moduleType == 'INV_PLAN_FTE_PROGRESS_DIFF_COLOR'; 

                            if (planFteColorNotShow) {
                                return
                            }
                            if( !(colorNotShow && item.allBusiness) ) {
                                return (
                                    <ColorBox
                                        {...item}
                                        key={item.moduleType}
                                        params={colorParams}
                                        refresh={refreshColor}
                                    />
                                );
                            }
                        })
                    }
                </div>
                <ChartFilter
                    params={chartParams}
                    activeKey={activeKey}
                    onExport={() => this.exportModalShow('chart',chartParams)}
                    onSearch={() => this.handleSearch('chart')}
                    onChange={value => this.handleChange(value, 'chart')}
                />
                <div className="flexBox">
                    {
                        chartBox[activeKey]
                        .filter(chart => !chart.chartTypes.includes('pie'))
                        .map(item => {
                            // "当月项目计划FTE/当月项目确认FTE"图表显示判断
                            const planFteColorNotShow = chartParams.statisticalRange !== "PROJECT" && item.moduleType == 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH'; 

                            if (planFteColorNotShow) {
                                return
                            }
                            if( !(chartNotShow && item.allBusiness) ) {
                                return (
                                    <ChartBox
                                        {...item}
                                        key={item.moduleType}
                                        params={chartParams}
                                        refresh={refreshChart}
                                    />
                                );
                            }
                        })
                    }
                </div>
                {
                    hasPieCharts &&
                    <ChartFilter
                        isPieChart
                        params={pieChartParams}
                        activeKey={activeKey}
                        onExport={() => this.handleExport('pieChart')}
                        onSearch={() => this.handleSearch('pieChart')}
                        onChange={value => this.handleChange(value, 'pieChart')}
                    />
                }
                {
                    hasPieCharts &&
                    <div className="flexBox">
                        {
                            pieCharts.map(item => {
                                return (
                                    <PieChartBox
                                        {...item}
                                        key={item.moduleType}
                                        params={pieChartParams}
                                        refresh={refreshPieChart}
                                    />
                                );
                            })
                        }
                    </div>
                }
                <ExportModal 
                    activeKey={activeKey} 
                    ref={ el => this.exportModalRef = el } 
                    export={this.handleExport}
                />
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/Dashboard.js